export default __webpack_public_path__ + "static/media/dbh.94413def.jpg";